const BRANDS = {
    superscore: {
        name: "SuperScore",
        brandLightLogoAsset: "SuperfluidLabs-white-logo-01-01.png",
        brandDarkLogoAsset: "SuperfluidLabs-white-logo-01-01.png",
        primaryColor: "#0af"
    },

    farmdrive: {
        name: "FarmDrive",
        brandLightLogoAsset: "farmdrive-logo.png",
        brandDarkLogoAsset: "farmdrive-logo.png",
        primaryColor: "#0aa425"
    },

    engie: {
        name: "Engie",
        brandLightLogoAsset: "engie-logo.svg",
        brandDarkLogoAsset: "engie-logo.svg",
        primaryColor: "#0af"
    },

    tulaa: {
        name: "Tulaa",
        brandLightLogoAsset: "tulaa-logo.png",
        brandDarkLogoAsset: "tulaa-logo.png",
        primaryColor: "#008f8a"
    },

    rensource: {
        name: "Rensource Energy",
        brandLightLogoAsset: "rensource-logo.png",
        brandDarkLogoAsset: "rensource-logo.png",
        primaryColor: "#F2C553"
    },

    spaces: {
        name: "Spaces",
        brandLightLogoAsset: "spaces-logo-dark.png",
        brandDarkLogoAsset: "spaces-logo-white.png",
        primaryColor: "#0af"
    },

    "spaces-bi": {
        name: "Spaces",
        brandLightLogoAsset: "spaces-logo-dark.png",
        brandDarkLogoAsset: "spaces-logo-white.png",
        primaryColor: "#0af"
    }
};

const SUB_DOMAIN = window.location.hostname.split('.')[0];

export const BRAND = (() => {
    const key = BRANDS.hasOwnProperty(SUB_DOMAIN) ? SUB_DOMAIN : "superscore";
    return BRANDS[key];
})();

export const IS_BETA = ["beta", "engie"].includes(SUB_DOMAIN) ||
    window.location.hostname === "localhost";